module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('mu-appbar', [_c('span', {
    staticClass: "topT"
  }, [_vm._v("持卡注册")]), _vm._v(" "), _c('mu-icon', {
    staticStyle: {
      "margin-bottom": "-0.05rem"
    },
    attrs: {
      "slot": "left",
      "value": "keyboard_arrow_left",
      "color": "white"
    },
    on: {
      "click": _vm.goback
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_left",
      "color": "#27ba69"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bigpage"
  }, [_c('div', {
    attrs: {
      "align": "left"
    }
  }, [_c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "请输入手机号",
      "type": "text",
      "icon": "smartphone"
    },
    model: {
      value: (_vm.UserPhone),
      callback: function($$v) {
        _vm.UserPhone = $$v
      },
      expression: "UserPhone"
    }
  }), _vm._v(" "), _c('nobr', [_c('mu-text-field', {
    staticClass: "txtValidate",
    staticStyle: {
      "margin-left": "-4%",
      "width": "72%"
    },
    attrs: {
      "hintText": "请输入短信验证码",
      "type": "text",
      "icon": "verified_user"
    },
    model: {
      value: (_vm.YZM),
      callback: function($$v) {
        _vm.YZM = $$v
      },
      expression: "YZM"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveYZM == false),
      expression: "haveYZM == false"
    }]
  }, [_c('input', {
    staticStyle: {
      "font-size": "0.32rem",
      "margin-left": "2%",
      "background-color": "#27ba69",
      "height": "0.65rem",
      "border": "none",
      "width": "27%",
      "color": "white"
    },
    attrs: {
      "type": "button",
      "id": "j-popup-1",
      "value": "获取"
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveYZM == true),
      expression: "haveYZM == true"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.WaitTime),
      expression: "WaitTime"
    }],
    staticStyle: {
      "font-size": "0.32rem",
      "margin-left": "2%",
      "background-color": "#eeeeee",
      "height": "0.65rem",
      "border": "none",
      "width": "27%",
      "color": "#999"
    },
    attrs: {
      "type": "button"
    },
    domProps: {
      "value": (_vm.WaitTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.WaitTime = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "请设置您的密码",
      "type": "password",
      "icon": "lock"
    },
    model: {
      value: (_vm.UserPass),
      callback: function($$v) {
        _vm.UserPass = $$v
      },
      expression: "UserPass"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "请输入您的真实姓名",
      "type": "text",
      "icon": "person "
    },
    model: {
      value: (_vm.RealName),
      callback: function($$v) {
        _vm.RealName = $$v
      },
      expression: "RealName"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "请输入银行卡号",
      "type": "text",
      "icon": "credit_card "
    },
    model: {
      value: (_vm.CardNum),
      callback: function($$v) {
        _vm.CardNum = $$v
      },
      expression: "CardNum"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.2rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.IsCheck),
      expression: "IsCheck"
    }],
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "type": "checkbox",
      "checked": "checked",
      "id": "IsCheck",
      "name": "IsCheck",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.IsCheck) ? _vm._i(_vm.IsCheck, "true") > -1 : (_vm.IsCheck)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.IsCheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.IsCheck = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.IsCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.IsCheck = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "font-size": "0.3rem",
      "margin-top": "0.35rem"
    },
    style: ({
      width: '100%',
      height: '0.8rem'
    }),
    attrs: {
      "label": "注 册",
      "primary": ""
    },
    on: {
      "click": _vm.Register
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "captcha"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.2rem"
    }
  }, [_vm._v("支持中信银行、兴业银行、建设银行持卡人注册 ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": this.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "display": "inline",
      "font-size": "0.24rem"
    },
    attrs: {
      "for": "IsCheck"
    }
  }, [_vm._v("\n        同意\n        "), _c('a', {
    attrs: {
      "href": "http://www.998.com/UserRegister/RegServicesNew"
    }
  }, [_vm._v("《格林会员服务条款》")]), _vm._v("\n        和\n        "), _c('a', {
    attrs: {
      "href": "http://www.998.com/UserRegister/RegPrivacy"
    }
  }, [_vm._v("《格林隐私声明》")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d23dfac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/NonVerified/CardHolderRegister.vue
// module id = 1478
// module chunks = 18